import { isApp, nativeTrack } from 'base/utils/app';
import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_TRACKER } from 'base/config/constant';
import { ISpPageViewData } from 'base/utils/tracker-sp';
import { trackAddToCart } from 'base/utils/tracker';

function track(methodName: string, data?: any) {
    if (!isApp()) {
        return;
    }
    if (getParamInSearch(DEBUG_TRACKER) === '1') {
        console.log(`-----App: ${methodName} -----`);
        if (data) {
            console.log(JSON.stringify(data, null, 4));
        }
    }

}

export function appPageView(data: ISpPageViewData) {
    nativeTrack('pv', [data]);
}

export function appProductsImpression(variants: Record<string, any>[]) {
    nativeTrack('productImpressions', [
        ...variants.map(variant => {
            const { quantity, ...rest } = variant;
            return {
                schema: 'iglu:com.google.analytics.enhanced-ecommerce/impressionFieldObject/jsonschema/1-0-0',
                data: rest
            }
        }),
        {
            schema: 'iglu:com.google.analytics.enhanced-ecommerce/action/jsonschema/1-0-0',
            data: {
                action: 'view',
            }
        },
    ]);
}

export function appProductClick(variant: Record<string, any>) {
    nativeTrack('productClick', [
        {
            schema: 'iglu:com.google.analytics.enhanced-ecommerce/productFieldObject/jsonschema/1-0-0',
            data: variant
        },
        {
            schema: 'iglu:com.google.analytics.enhanced-ecommerce/action/jsonschema/1-0-0',
            data: {
                action: 'click',
            }
        }
    ]);
}

export function appCtrImpressions(data: Record<string, any>[]) {
    nativeTrack('ctrImpressions', data);
}

export function appCtrClick(data: Record<string, any>[]) {
    nativeTrack('ctrClick', data);
}

export function appAddToCart(variants: Record<string, any>[]) {
    nativeTrack('addToCart', [
        ...variants.map(variant => ({
            schema: 'iglu:com.google.analytics.enhanced-ecommerce/productFieldObject/jsonschema/1-0-0',
            data: variant
        })),
        {
            schema: 'iglu:com.google.analytics.enhanced-ecommerce/action/jsonschema/1-0-0',
            data: {
                action: 'add',
            }
        }
    ]);
}



